import React from 'react';
import { useSelector } from 'react-redux';
import { capitalize, isNil } from 'lodash';
import cx from 'classnames';
import styles from './Overview.module.scss';
import LoadableMonacoEditor from 'js/components/elements/editors/monaco/LoadableMonacoEditor';
import { TransformType } from 'new/components/ReusableTransform/types';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_TRANSFORM_DOC_REQUEST } from 'js/constants/actionTypes';
import DocEditor from 'js/components/elements/editors/DocEditor';
import { useResourceDoc } from 'new/hooks/adapters/useResourceDoc';
import { RESOURCE_TYPE_RECORD_TRANSFORM } from 'js/constants/resourceTypes';

interface ReusableTxProps {
  resource: any;
}

export const ReusableTxOverview = (props: ReusableTxProps) => {
  const { resource } = props;
  const doc = useResourceDoc(RESOURCE_TYPE_RECORD_TRANSFORM, resource?.id);
  const { decoded } = useSelector((state: any) => state.transforms.allTransforms);
  const isLoadingDoc = useIsLoading(GET_TRANSFORM_DOC_REQUEST);
  let decodedCode = resource.decoded || decoded[resource.id]?.decoded;
  let codeLanguage = resource.codeLanguage || decoded[resource.id]?.codeLanguage;
  let isAttributeTx = resource.output_type === TransformType.ATTRIBUTE;
  let code_type = (isAttributeTx ? resource.code_type : codeLanguage) || 'json';

  let codeEditorMode = 'json';
  let displayLanguage = 'Nexla JSON';

  if (code_type === 'javascript' || code_type === 'python') {
    codeEditorMode = code_type;
    displayLanguage = capitalize(code_type);
  }

  return (
    <div
      className={cx(styles.overviewContainer, styles.reusableTxOverviewContainer, 'detail-view')}
    >
      <div className="tab-content">
        {!isNil(doc) && !isLoadingDoc ? (
          <DocEditor data={resource} doc={doc} readOnly isLoading={isLoadingDoc} />
        ) : null}
        <div className={styles.transform_code_header}>
          <span className={styles.title}>Transform Code &gt;&gt; {displayLanguage}</span>
        </div>
        <div className={styles.monaco_editor_container}>
          <LoadableMonacoEditor
            language={codeEditorMode}
            height={500}
            value={decodedCode}
            theme="light"
            options={{
              readOnly: true,
              minimap: { enabled: false },
            }}
          />
        </div>
      </div>
    </div>
  );
};
